export default __webpack_public_path__ + "locales/pt-BR/VersionHistory.json?hash=25a84c8a344949f5025997ac7fd1a554";